import React, { useEffect, useState } from "react";
// import swiper
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation } from "swiper";
// import images
import labtopimg from "../../images/PopularProducts/02_00_287x.avif";
import tvimg from "../../images/PopularProducts/08_00_287x.avif";
import cameraimg from "../../images/PopularProducts/19_00_287x.avif";
import "./PopularProducts.css";
import headphoneimg from "../../images/PopularProducts/07_110x110.avif";
import grap from "../../images/PopularProducts/grap.jpg";
// import css file
import "./PopularProducts.css";
// import component
import ProductCard from "../../components/product_card/ProductCard";
const PopularProducts = () => {
  // start function loading clicked products
  const [products, setproducts] = useState([]);
  const LoadingProducts = (e) => {
    let AllLinks = document.querySelectorAll(".Products_menu ul li");
    AllLinks.forEach((link) => {
      link.addEventListener("click", (e) => {
        e.preventDefault();
        let ourapi = `https://rus-digital-televisions.onrender.com/${e.target.dataset.name}`;
        fetch(ourapi)
          .then((res) => res.json())
          .then((data) => setproducts(data.slice(0, 10)));
      });
    });
  };
  useEffect(() => {
    fetch("https://rus-digital-televisions.onrender.com/televisions")
      .then((res) => res.json())
      .then((data) => setproducts(data.slice(0, 10)));
    LoadingProducts();
  }, []);

  return (
    <>
      <div className="Popular_Products ">
        <div className="container-fluid">
          <div className="title py-3">
            <h5>Our Popular Products</h5>
            <div
              className="Navigation"
              style={{ position: "absolute", right: "10px" }}
            >
              <div className="swiper-button-next"></div>
              <div
                className="swiper-button-prev"
                style={{
                  left: "-81px",
                }}
              ></div>
            </div>
          </div>
          <div className="row">
            <div className=" Products_menu col-lg-2 col-md-12 col-sm-12">
              <ul style={{ listStyle: "none" }}>
                <li>
                  <img src={tvimg} alt="popularproducts"></img>
                  <a href="Televisions" data-name="televisions">
                    Televisions
                  </a>
                </li>
                <li>
                  <img src={labtopimg} alt="popularproducts"></img>
                  <a href="Computers" data-name="computers">
                    Computers
                  </a>
                </li>
                <li>
                  <img src={headphoneimg} alt="popularproducts"></img>
                  <a href="HeadPhones" data-name="headphones">
                    HeadPhones
                  </a>
                </li>
                <li>
                  <img src={cameraimg} alt="popularproducts"></img>
                  <a href="Cameras" data-name="cameras">
                    Cameras
                  </a>
                </li>
                <li>
                  <img src={grap} alt="popularproducts"></img>
                  <a href="Accessoris" data-name="accessories">
                    Accessoris
                  </a>
                </li>
              </ul>
            </div>
            <div className="popular-products-right col-lg-10 col-md-12 col-sm-12">
              <div className="fixed-div rounded-3"></div>
              <div className="clicked-products">
                <Swiper
                  loop={true}
                  breakpoints={{
                    320: {
                      slidesPerView: 1,
                      spaceBetween: 20,
                    },
                    // when window width is >= 480px
                    480: {
                      slidesPerView: 1,
                      spaceBetween: 10,
                    },
                    // when window width is >= 640px
                    640: {
                      slidesPerView: 2,
                      spaceBetween: 10,
                    },
                    992: {
                      slidesPerView: 3,
                      spaceBetween: 10,
                    },
                  }}
                  pagination={{
                    clickable: true,
                  }}
                  navigation={{
                    clickable: true,
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                  }}
                  modules={[Navigation]}
                  className="mySwiper productsSwipper"
                >
                  {products
                    ? products.map((product) => {
                        return (
                          <SwiperSlide key={product.id}>
                            <ProductCard
                              productimg={product.img}
                              name={product.name.slice(0, 60)}
                              discount={product.discount}
                              price={product.price}
                              productdetails={product}
                            />
                          </SwiperSlide>
                        );
                      })
                    : console.log("loading")}
                </Swiper>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PopularProducts;
